/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

export { ViewTeamContainer as ViewTeam } from './ViewTeam.container';
